/* globals console, document, module, navigator, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    ModalDialog = require('./modalDialog'),
    Wizard = require('./wizard'),
    FilterSet = require('./filterSet'),
    user = require('../models/user'),
    configuration = require('../utilities/configuration'),
    // formProcessor = require('../utilities/formProcessor').processor,
    AddressAutocomplete = require('../utilities/addressAutocomplete'),
    templates = require('../utilities/handlebars').templates;
    // EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'programs-sidebar-filter'
    },
    channels: {
        out: BackboneRadio.channel('vaultInterface:out'),
        program: BackboneRadio.channel('program')
    },
    childViewEvents: {
        'apply:filterSet':     'onApplyFilterSet',
        'apply:wizardFilters': 'onApplyWizardFilters',
        'clear:allGroups':     'onClearAllGroups',
        'clear:group':         'onClearGroup',
        'jump:hb101':          'onJumpHb101',
        'location:cleared':    'onLocationCleared'
    },
    collapseAll: true, // assumes we start with all filters expanded
    events: {
        'change input':               'onChangeInputSelect',
        'change select':              'onChangeInputSelect',
        'click button':               'onClickButton',
        // 'click img[name=geolocate]':  'onClickGeolocate',
        'dblclick div[name=cardHeader]': 'onDoubleClickHeader'
    },
    regions: {
        filterSet: 'div[name=filterSet]',
        wizard: 'div[name=wizard]'
    },
    tagName: 'div',
    template: templates.programsSidebarFilter,
    ui: {
        form:            'form[name=programsSidebarFilter]',
        // geolocate:       'img[name=geolocate]',
        keywords:        'input[name=keywords]',
        latitude:        'input[name=latitude]',
        location:        'input[name=location]',
        locationComment: 'small[name=locationComment]',
        longitude:       'input[name=longitude]',
        sortby:          'input[name=sortby]',
        miles:           'select[name=miles]'
    },
    //
    clearAllGroups: function () {
        const groups = _.concat(['distance', 'keywords', 'sortby', 'vacancyFavoritesPrograms'], _.keys(this.templateContext.cards));
        _.each(groups, _.bind(function (group) {
            this.clearGroup(group, true);
            this.trigger('group:cleared', group);
        }, this));
        this.onChangeInputSelect('clearAllGroups');
    },
    clearGroup: function (group, skipOnChangeInputSelect) {
        // if (group === 'vacancyFavoritesPrograms') {
        //     console.log('@d');
        // }
        switch (group) {
            case 'vacancy':
            case 'isFavorite':
            case 'hasAdminAccess':
                jQuery('div[name=' + group + '] input:checkbox', this.$el).prop('checked', false);
                break;
            case 'distance':
                this.ui.location.val('');
                this.ui.latitude.val(-1);
                this.ui.longitude.val(-1);
                this.ui.miles.find('option').eq(0).prop('selected', true);
                break;
            case 'keywords':
            case 'sortby':
                this.ui[group].val('');
                break;
            default:
                jQuery('div[name=' + group + 'Card] input:checkbox', this.$el).prop('checked', false);
                jQuery('div[name=' + group + 'Card] option', this.$el).prop('selected', false);
                break;
        }
        if (!skipOnChangeInputSelect) {
            this.onChangeInputSelect('clearGroup');
        }
    },
    close: function (callback) {
        if (this.modalDialog) { this.modalDialog.close(); }
        if (this.wizard) {
            this.wizard.close();
        }
        callback(null);
    },
    initialize: function () {
        this.filters = this.options.filters;
        this.templateContext = {
            cards: {
                // these are in the order they should appear in the sidebar so don't sort these (as tempting as it may be...)
                householdTypeIds:           {title: 'householdTypeTitle',           skipOther: true,  help: null},
                serviceForDiagnosisTypeIds: {title: 'serviceForDiagnosisTypeTitle', skipOther: true,  help: 'serviceForDiagnosisTypeTitleHelp'},
                canServeMAWaiversTypeIds:   {title: 'canServeMAWaiversTypeTitle',   skipOther: true,  help: 'canServeMAWaiversTypeTitleHelp'},
                criminalBackgroundTypeIds:  {title: 'criminalBackgroundTypeTitle',  skipOther: true,  help: 'criminalBackgroundTypeTitleHelp'},
                serviceOnSiteTypeIds:       {title: 'serviceOnSiteTypeTitle',       skipOther: true,  help: 'serviceOnSiteTypeTitleHelp'},
                buildingAccessTypeIds:      {title: 'buildingAccessTypeTitle',      skipOther: true,  help: 'buildingAccessTypeTitleHelp'},
                sobrietyPolicyTypeId:       {title: 'sobrietyPolicyTypeTitle',      skipOther: true,  help: 'sobrietyPolicyTypeTitleHelp'},
                sobrietyPeriodTypeId:       {title: 'sobrietyPeriodTypeTitle',      skipOther: true,  help: 'sobrietyPeriodTypeTitleHelp'},
                smokingPolicyTypeId:        {title: 'smokingPolicyTypeTitle',       skipOther: true,  help:  null},
                petPolicyTypeIds:           {title: 'petPolicyTypeTitle',           skipOther: false, help:  null},
                programTypeId:              {title: 'programTypeTitle',             skipOther: true,  help: 'programTypeTitleHelp'}
                // languagesSpokenTypeIds:     {title: 'languagesSpokenTypeTitle',     skipOther: true, help:  null},
                // mealsServedTypeId:          {title: 'mealsServedTypeTitle',         skipOther: true, help: 'mealsServedTypeTitleHelp'},
                // kitchenTypeId:              {title: 'kitchenTypeTitle',             skipOther: true, help: 'kitchenTypeTitleHelp'},
                // incomeSupportTypeIds:       {title: 'incomeSupportTypeTitle',       skipOther: true, help: 'incomeSupportTypeTitleHelp'},
            },
            mobile: this.options.mobile
        };
        _.defer(_.bind(function () {
            const input = this.$el.parent().find('input[name=location]')[0];
            this.addressAutocomplete = new AddressAutocomplete(input, _.bind(this.updateLocation, this));
            this.onClickGeolocate();
            this.onChangeInputSelect('initialize');
        }, this));
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.onRoleChange();
        }, this));
        this.listenTo(this.channels.program, 'update', function () {
            this.onChangeInputSelect('update');
        });
    },
    latitudeLongitude: function (latitudeLongitude) {
        this.resolveLocation(latitudeLongitude.latitude + ', ' + latitudeLongitude.longitude);
    },
    onApplyFilterSet: function (filterSet) {
        const el = this.$el,
            ignoreGroups = {
                location: true
            },
            latitudeLongitude = {};
        this.clearAllGroups();
        _.each(filterSet, function (values, group) {
            // console.log('programsSidebarFilter.onApplyFilterSet - %s:%s', group, JSON.stringify(values));
            if (ignoreGroups[group]) {
                return;
            }
            if (_.isArray(values)) {
                _.each(values, function (value) {
                    const selector = 'div[name=' + group + 'Card] input:checkbox[data-id=' + value + ']';
                    jQuery(selector, el).prop('checked', true);
                });
            } else if (_.isBoolean(values)) {
                if (values === true) {
                    switch (group) {
                        case 'vacancy':
                        case 'isFavorite':
                        case 'hasAdminAccess':
                            jQuery('div[name=vacancyFavoritesProgramsCard] input[name=' + group + ']:checkbox', el).prop('checked', true);
                            break;
                        default:
                            // console.log('programsSidebarFilter.onApplyFilterSet.boolean.default');
                            jQuery('div[name=' + group + 'Card] input:checkbox', el).prop('checked', true);
                            break;
                    }
                }
            } else if (_.isPlainObject(values)) {
                _.each(values, function (value, key) {
                    let selector;
                    switch (key) {
                        case 'miles':
                            selector = 'div[name=' + group + 'Card] select[name=' + key + ']';
                            break;
                        case 'latitude':
                        case 'longitude':
                            latitudeLongitude[key] = value; // jshint ignore:line
                            // intentionally fall through...
                        default:
                            selector = 'div[name=' + group + 'Card] input[name=' + key + ']';
                            break;
                    }
                    jQuery(selector, el).val(value);
                });
            } else if (_.isInteger(values)) {
                switch (group) {
                    case 'invalidateCache':
                        jQuery('input[name=' + group + ']', el).val(values);
                        break;
                    default:
                        console.log('programsSidebarFilter.onApplyFilterSet - unknown values group (%s) for value type integer', group);
                        break;
                }
            } else {
                console.log('programsSidebarFilter.onApplyFilterSet - unknown values type for group (%s)', group);
            }
        });
        this.onChangeInputSelect('onApplyFilterSet');
        if (latitudeLongitude.latitude && latitudeLongitude.longitude) {
            this.trigger('latitudeLongitude:updated', {latitude: latitudeLongitude.latitude, longitude: latitudeLongitude.longitude, source: 'programsSidebarFilter.onApplyFilterSet'});
        }
    },
    onApplyWizardFilters: function (processedFilters) {
        this.onApplyFilterSet(processedFilters);
    },
    onChangeFavorite: function () {
        if (this.$el.find('input[name=isFavorite]').is(':checked')) {
            this.$el.find('input[name=invalidateCache]').val(new Date().getTime());
            this.onChangeInputSelect('onChangeFavorite');
        }
    },
    onChangeInputSelect: function (via) {
        // console.log('programsSidebarFilter.onChangeInputSelect - via:%s', via);
        const serializedValues = this.serializeForm();
        this.collection.applyFilters(serializedValues, 'programsSidebarFilter', via === 'update');
        this.getChildView('filterSet').updateFilters(serializedValues, via);
    },
    onClearAllGroups: function () {
        this.clearAllGroups();
    },
    onClearGroup: function (group) {
        this.trigger('group:cleared', group);
        this.clearGroup(group);
    },
    onClickButton: function (event) {
        let action = null;
        if (!event.action && !event.currentTarget) {
            return;
        }
        if (event.currentTarget && event.currentTarget.dataset.toggle === 'popover') {
            // don't let popover clicks (for example) bubble up to header...
            return false;
        }
        action = event.action || event.currentTarget.dataset.action;
        if (!action) {
            return;
        }
        switch (action) {
            case 'about':
                this.modalDialog = new ModalDialog({template: templates.about, templateContext: {}, modalModal: false});
                this.listenTo(this.modalDialog, 'modalDialog:cancel', function () {
                    this.$el.find('button[name=about]').focus();
                });
                break;
            case 'geolocate':
                this.onClickGeolocate();
                break;
            case 'listings':
                this.trigger('display:section', 'listings');
                break;
            case 'video':
                this.modalDialog = new ModalDialog({template: templates.helpVideo, templateContext: {}, modalModal: false});
                this.listenTo(this.modalDialog, 'modalDialog:cancel', function () {
                    this.$el.find('button[name=video]').focus();
                });
                break;
            case 'wizard':
                this.wizard = this.showChildView('wizard', new Wizard({collection: this.collection, filters: this.filters}));
                this.listenTo(this.wizard, 'wizard:close', function () {
                    this.wizard = null;
                    this.trigger('wizard:closed');
                    _.defer(_.bind(function () {
                        this.$el.find('button[name=wizard]').focus();
                    }, this));
                });
                break;
            default:
                break;
        }
        return false;
    },
    onClickGeolocate: function () {
        const defaultLatitude = configuration.geolocations[configuration.geolocation].latitude,
            defaultLongitude = configuration.geolocations[configuration.geolocation].longitude;
        if (configuration.useGeolocation && navigator.geolocation) {
            try {
                navigator.geolocation.getCurrentPosition(_.bind(function (position) {
                    const latitude = position.coords.latitude ? position.coords.latitude : defaultLatitude,
                        longitude  = position.coords.longitude ? position.coords.longitude : defaultLongitude;
                    this.resolveLocation(latitude + ', ' + longitude);
                }, this), function (error) {
                    console.log('@programsSidebarFilter.getCurrentPosition - error callback', error);
                });
            } catch (error) {
                console.log('@programsSidebarFilter.getCurrentPosition - try/catch error', error);
            }
        } else {
            // browser doesn't support geolocation
            this.resolveLocation(defaultLatitude + ', ' + defaultLongitude);
        }
    },
    onDoubleClickHeader: function () {
        // collapse/expand all the filters
        this.$el.find('.collapse').collapse('toggle', this.collapseAll);
        if (document.selection && document.selection.empty) {
            document.selection.empty();
        } else if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
        this.collapseAll = !this.collapseAll;
        return false;
    },
    onJumpHb101: function () {
        this.channels.out.trigger('hostNavigateTo', {target: '/'});
    },
    onLocationCleared: function () {
        this.trigger('latitudeLongitude:updated', {latitude: -1, longitude: -1, source: 'programsSidebarFilter.onLocationCleared'});
    },
    onRender: function () {
        this.showChildView('filterSet', new FilterSet({filters: this.filters, serializeFilters: _.bind(this.serializeForm, this)}));
        jQuery('[data-toggle="popover"]', this.$el).popover({
            trigger: 'focus',
            html: true,
            content: function () {
                return jQuery('span', this).text();
            }
        });
        this.ui.location.focus(_.bind(function () {
            this.priorAddressAutocomplete = this.ui.location.val();
        }, this));
        this.ui.location.blur(_.bind(function () {
            // remove any text on blur and, if an autocomplete has occurred, display the formatted address above
            if (this.ui.location.val() !== this.priorAddressAutocomplete) {
                this.ui.location.val('');
            }
        }, this));
        this.onRoleChange();
        // Hide "minor youth" as a filter.
        jQuery('[id*="householdTypeIds_4"]', this.$el).parent().addClass('d-none');
    },
    onRoleChange: function () {
        // @acavan! TODO - later use body class role instead
        this.$el.find('div[name=isFavorite]').toggleClass('hidden', !user.hasCapability('enrollee'));
        this.$el.find('div[name=hasAdminAccess]').toggleClass('hidden', !user.hasCapability('organization') || user.hasCapability('administrator'));
    },
    pseudofilter: function (filter) {
        const currentValue = this.ui[filter.group].val();
        if (currentValue === filter.value || (currentValue === '' && _.isNil(filter.value))) {
            return;
        }
        this.ui[filter.group].val(filter.value);
        this.onChangeInputSelect('pseudofilter');
    },
    resolveLocation: function (location) {
        // console.log('@programsSidebarFilter.resolveLocation', location);
        this.addressAutocomplete.resolveLocation(location, _.bind(function (error, resolvedLocation) { // jscs:disable disallowDanglingUnderscores
            if (!this._isDestroyed) { // eslint-disable-line  no-underscore-dangle
                this.updateLocation(resolvedLocation);// jscs:enable disallowDanglingUnderscores
            }
        }, this));
    },
    serializeForm: function () {
        return this.ui.form.serializeArray();
    },
    updateLocation: function (location) {
        // console.log('@programsSidebarFilter.updateLocation', location);
        if (!location.error) {
            this.ui.locationComment.text('');
            this.ui.latitude.val(location.latitude || '');
            this.ui.longitude.val(location.longitude || '');
            this.priorAddressAutocomplete = location.formattedAddress;
            this.ui.location.val(location.formattedAddress).blur();
            if (location.latitude && location.longitude) {
                this.onChangeInputSelect('updateLocation');
                this.trigger('latitudeLongitude:updated', {latitude: location.latitude, longitude: location.longitude, source: 'programsSidebarFilter.updateLocation'});
            }
        } else {
            this.ui.locationComment.text(location.error);
        }
    }
    // wizardify: function () {
    //     this.wizard = this.showChildView('wizard', new Wizard({collection: this.collection, filters: this.filters}));
    //     this.listenTo(this.wizard, 'wizard:close', function (event) {
    //         this.wizard = null;
    //         this.trigger('wizard:closed');
    //     });
    // }
});
